import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import InputGroup from "../InputGroup/InputGroup"

import "./TimelineInputs.css"

const initialInputs = [
  {
    id: 7,
    userField: "timeline",
    inputType: "date",
    type: "date",
    placeHolder: "What is your separation date? (MM/DD/YYYY)",
    title: "What is your separation date? (MM/DD/YYYY)",
    required: true,
  }
]

const TimelineInputs = (props) => {
  const application = useSelector((state) => {
    return state.spouseApplication.application;
  });
  const inputDataWithValues = initialInputs.map((input) => {
    let value = Object.byString(application, input.userField) || ""
    return {
      ...input,
      value
    }
  })

  const requiredValidators = (input) => ({
    ...input,
    error: !!(input.required && input.value.length === 0)
  })

  const dateOfBirthValidator = (input) => {
    if (input.textField === "dateOfBirth") {
      return {
        ...input,
        error: true
      }
    }
    return input
  }


  return (
    <InputGroup
      {...props}
      containerClass="singleGridContainer"
      inputData={inputDataWithValues}
      renderComponent={({ inputComponent, inputData, checkSubmittability }) => {
        return (
          <>
            {props.renderComponent({
              ...props,
              inputData,
              checkSubmittability,
              inputComponent,
              validators: [requiredValidators, dateOfBirthValidator]
            })}
          </>
        )
      }}
    />
  )
}

export default TimelineInputs
